export const aboutData = {
  brandName: "苍井樱官方资料站",
  brandIntro: "苍井樱官方资料站创立于2020年，是国内最早专注于苍井樱资讯的中文平台之一。我们致力于为广大华语粉丝提供最全面、最权威、最及时的苍井樱相关资讯。",
  mission: "我们的使命是搭建苍井樱与华语粉丝之间的桥梁，让每一位喜爱苍井樱的粉丝都能在这里找到想要的信息，感受偶像的魅力与温暖。",
  history: [
    { year: "2020", event: "苍井樱官方资料站正式上线，首发苍井樱完整个人档案" },
    { year: "2021", event: "新增作品数据库，收录苍井樱全部作品信息" },
    { year: "2022", event: "推出图片专区，汇聚千余张高清写真与活动照片" },
    { year: "2023", event: "开通新闻动态频道，实现苍井樱最新资讯每日更新" },
    { year: "2024", event: "网站全面改版升级，推出粉丝社区互动功能" },
  ],
  values: [
    { title: "权威可靠", description: "所有信息均经过严格核实，确保内容真实准确", icon: "ri-shield-check-line" },
    { title: "及时更新", description: "第一时间发布苍井樱最新动态与活动资讯", icon: "ri-timer-flash-line" },
    { title: "内容丰富", description: "涵盖个人档案、作品、图片、新闻等全方位信息", icon: "ri-stack-line" },
    { title: "粉丝为先", description: "以粉丝需求为导向，不断优化用户体验", icon: "ri-heart-line" },
  ],
  testimonials: [
    {
      name: "樱花漫舞",
      role: "资深粉丝（关注 6 年）",
      content: "苍井樱官方资料站是我每天必看的网站！资讯更新非常及时，作品数据库也非常全面。推荐给所有苍井樱的粉丝！",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%2C%20friendly%20smile%2C%20casual%20outfit%2C%20warm%20lighting%2C%20clean%20simple%20background%2C%20profile%20photo%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    },
    {
      name: "东京的樱",
      role: "在日华人粉丝",
      content: "作为在日本的华人粉丝，这个网站让我能够方便地用中文获取苍井樱的最新消息，比日文网站方便太多了！",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%2C%20gentle%20smile%2C%20modern%20casual%20style%2C%20soft%20lighting%2C%20clean%20simple%20background%2C%20profile%20photo%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    },
    {
      name: "樱之守护者",
      role: "站内活跃用户",
      content: "资料站的分类做得特别好，找作品、找图片都很方便。粉丝社区的氛围也很棒，认识了很多志同道合的朋友！",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%2C%20warm%20smile%2C%20casual%20style%2C%20soft%20lighting%2C%20clean%20simple%20background%2C%20profile%20photo%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
    },
  ],
  stats: [
    { value: "50万+", label: "月活跃用户" },
    { value: "2000+", label: "收录作品" },
    { value: "5000+", label: "高清图片" },
    { value: "3000+", label: "新闻报道" },
  ],
  contactInfo: {
    email: "contact@aoi-sakura-info.example.com",
    weibo: "@苍井樱官方资料站",
    wechat: "SakuraInfo2020",
    address: "中国上海市浦东新区",
  },
};